function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlayTemplate = require('./saito-overlay.template');

/**
 * Generic class for creating an overlay (i.e. a popup box for information or interaction)
 * A callback can be associated with closing the overlay
 * By default, a close button is included
 */
var SaitoOverlay = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param app - the Saito Application
   * @param withCloseBox - a flag (default = true) to have a close button in the corner of the overlay
   * @param removeOnClose - a flag (default = true) to delete the overlay when closing it
   * @param clickToClose - clicking on overlay removes it
   */
  function SaitoOverlay(app, mod) {
    var withCloseBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var removeOnClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var clickToClose = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    _classCallCheck(this, SaitoOverlay);
    this.app = app;
    this.mod = mod;
    this.ordinal = 0;
    this.closebox = withCloseBox;
    this.clickToClose = clickToClose;
    this.clickBackdropToClose = true;
    this.removeOnClose = removeOnClose;
    this.callback_on_close = null;
    this["class"] = 'saito-overlay';
    this.zIndex = 100;
    this.visible = false;
    //flag to not add the backdrop
    this.nonBlocking = false;
  }
  return _createClass(SaitoOverlay, [{
    key: "pullOverlayToFront",
    value: function pullOverlayToFront() {
      var _this = this;
      var max_z_index_bg = 0;
      var max_z_index = 0;
      var max = 0;
      if (!document) {
        return;
      }
      Array.from(document.querySelectorAll('.saito-overlay')).forEach(function (ov) {
        var temp = parseInt(ov.style.zIndex);
        if (temp > max) {
          max = temp;
        }
      });
      max_z_index_bg = 100 + max + 2;
      max_z_index = 100 + max + 3;
      var qs = "saito-overlay".concat(this.ordinal);
      var obj = document.getElementById(qs);
      if (obj) {
        obj.style.zIndex = max_z_index;
        obj.style.display = 'block';
      }
      var qs2 = "saito-overlay-backdrop".concat(this.ordinal);
      var obj2 = document.getElementById(qs2);
      if (obj2) {
        obj2.style.zIndex = max_z_index_bg;
        obj2.style.display = 'block';
      }
      setTimeout(function () {
        var elsq = "#saito-overlay".concat(_this.ordinal);
        var bdelsq = "#saito-overlay-backdrop".concat(_this.ordinal);
        var overlay_el = document.querySelector(elsq);
        var overlay_backdrop_el = document.querySelector(bdelsq);
        if (overlay_backdrop_el) {
          overlay_backdrop_el.style.display = 'block';
        }
        if (overlay_el) {
          overlay_el.style.display = 'block';
        }
      }, 50);
    }

    /**
     * Create the DOM elements if they don't exist. Called by show
     * @param app - the Saito Application
     * @param mod - the calling module
     */
  }, {
    key: "render",
    value: function render() {
      var app = this.app;
      var mod = this.mod;
      if (!document) {
        return;
      }
      if (this.ordinal == 0) {
        var max = 0;
        Array.from(document.querySelectorAll('.saito-overlay')).forEach(function (ov) {
          var temp = parseInt(ov.id.replace('saito-overlay', ''));
          if (temp > max) {
            max = temp;
          }
        });
        this.ordinal = max + 1;
      }

      //
      //
      //
      this.zIndex = 100 + 2 * this.ordinal + 1;
      var qs = "saito-overlay-backdrop".concat(this.ordinal);
      if (!document.getElementById(qs)) {
        this.app.browser.addElementToDom(SaitoOverlayTemplate(this));
      }
      this.visible = true;
    }

    /**
     * Does nothing
     * @param app - the Saito Application
     * @param mod - the calling module
     */
  }, {
    key: "attachEvents",
    value: function attachEvents() {}

    /**
     * Renders the Overlay with the given html and attaches events to close it
     * @param app - the Saito application
     * @param mod - the calling module
     * @param html - the content for the overlay
     * @param mycallback - a function to run when the user closes the overlay
     *
     */
  }, {
    key: "show",
    value: function show() {
      var _this2 = this;
      var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var mycallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var app = this.app;
      var mod = this.mod;
      if (!document) {
        return;
      }
      this.render();
      var overlay_self = this;
      var overlay_el = document.getElementById("saito-overlay".concat(this.ordinal));
      var overlay_backdrop_el = document.getElementById("saito-overlay-backdrop".concat(this.ordinal));
      this.callback_on_close = mycallback;
      try {
        overlay_el.style.display = 'block';
        if (overlay_backdrop_el && !this.nonBlocking) {
          overlay_backdrop_el.style.display = 'block';
        }
        if (html) {
          if (this.closebox) {
            overlay_el.innerHTML = "<div id=\"saito-overlay-closebox".concat(this.ordinal, "\" class=\"saito-overlay-closebox\"><i class=\"fas fa-times-circle saito-overlay-closebox-btn\"></i></div>") + html;
            //Close by clicking on closebox
            var closebox_qs = "#saito-overlay-closebox".concat(this.ordinal);
            var closebox_el = document.querySelector(closebox_qs);
            closebox_el.onclick = this.close.bind(this);

            //Adjust position of closebox for full screen overlay
            setTimeout(function () {
              overlay_el = document.getElementById("saito-overlay".concat(_this2.ordinal));
              if (overlay_el) {
                var box = overlay_el.getBoundingClientRect();
                if (box.width + 30 > window.innerWidth || box.height + 30 > window.innerHeight || _this2.nonBlocking) {
                  overlay_el.classList.add('maximized-overlay');
                }
                closebox_el.style.display = 'block';
              }
            }, 10);
          } else {
            overlay_el.innerHTML = html;
          }
        }
        if (overlay_backdrop_el) {
          if (this.clickBackdropToClose) {
            overlay_backdrop_el.onclick = this.close.bind(this);
          } else {
            overlay_backdrop_el.onclick = function () {};
          }
        }
        if (this.clickToClose) {
          overlay_el.onclick = this.close.bind(this);
        } else {
          overlay_el.onclick = function () {};
        }
      } catch (err) {
        console.error('OVERLAY ERROR:', err);
      }
    }

    /**
     * Hide all the overlay elements from view
     *
     */
  }, {
    key: "close",
    value: function close() {
      this.hide();
      if (this.callback_on_close != null) {
        this.callback_on_close();
      }
      if (this.removeOnClose) {
        this.remove();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      if (!document) {
        return;
      }
      if (this.callback_on_close != null) {
        this.callback_on_close();
      }
      this.visible = false;
      var elsq = "#saito-overlay".concat(this.ordinal);
      var bdelsq = "#saito-overlay-backdrop".concat(this.ordinal);
      var overlay_el = document.querySelector(elsq);
      var overlay_backdrop_el = document.querySelector(bdelsq);
      if (overlay_backdrop_el) {
        overlay_backdrop_el.style.display = 'none';
      }
      if (overlay_el) {
        overlay_el.style.display = 'none';
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      this.visible = false;
      try {
        var overlay_el = document.querySelector("#saito-overlay".concat(this.ordinal));
        if (overlay_el != null) {
          overlay_el.remove();
        }
        var overlay_backdrop_el = document.querySelector("#saito-overlay-backdrop".concat(this.ordinal));
        if (overlay_backdrop_el != null) {
          overlay_backdrop_el.remove();
        }
        this.ordinal = 0;
        this.callback_on_close = null;
      } catch (err) {
        console.error(err);
      }
    }

    //
    // The following functions are ported over from the old GameOverlay to retain
    // backwards compatibility of code written for that component. We should eventually
    // purge these from the main UI component or push them down to sub-components in
    // the games which inherit from the main overlay class and add this functionality.
    //
    /**
     * Backwards compatible show function
     * @param app - the Saito application
     * @param mod - the calling module
     * @param html - the content for the overlay
     * @param mycallback - a function to run when the user closes the overlay
     *
     */
  }, {
    key: "showOverlay",
    value: function showOverlay(html) {
      var mycallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.show(html, mycallback);
    }

    /**
     * Backwards compatible hide functino
     * @param mycallback - a function to run on completion
     */
  }, {
    key: "hideOverlay",
    value: function hideOverlay() {
      var mycallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.hide();
    }

    /**
     * Turn off event listerner for clicking outside overlay to close it
     * @param target_btn (optional) specify selector for an element that user is supposed to click to close overlay
     */
  }, {
    key: "blockClose",
    value: function blockClose() {
      var _this3 = this;
      var target_btn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var qs = "#saito-overlay-backdrop".concat(this.ordinal);
      var overlay_backdrop_el = document.querySelector(qs);
      if (overlay_backdrop_el) {
        overlay_backdrop_el.onclick = function (e) {
          if (target_btn) {
            var close_btn = document.querySelector(target_btn);
            if (close_btn) {
              var c1 = window.getComputedStyle(close_btn).color;
              var c2 = window.getComputedStyle(close_btn).backgroundColor;
              close_btn.style.color = c2;
              close_btn.style.backgroundColor = c1;
              setTimeout(function () {
                if (!close_btn) return;
                close_btn.style.color = c1;
                close_btn.style.backgroundColor = c2;
                setTimeout(function () {
                  if (!close_btn) return;
                  close_btn.style.color = c2;
                  close_btn.style.backgroundColor = c1;
                  setTimeout(function () {
                    if (!close_btn) return;
                    close_btn.style.color = c1;
                    close_btn.style.backgroundColor = c2;
                  }, 300);
                }, 300);
              }, 300);
              return;
            }
          }
          var closebox_qs = "#saito-overlay-closebox".concat(_this3.ordinal);
          var closebox_el = document.querySelector(closebox_qs);
          if (closebox_el) {
            closebox_el.style.transform = 'rotate(180deg)';
            setTimeout(function () {
              closebox_el.style.transform = '';
            }, 500);
          }
        };
      }
    }
  }, {
    key: "move",
    value: function move(x, y) {
      var overlay_el = document.querySelector("#saito-overlay".concat(this.ordinal));
      if (overlay_el) {
        overlay_el.classList.remove('center-overlay');
        overlay_el.style.top = "".concat(x, "px");
        overlay_el.style.left = "".concat(y, "px");
      }
    }

    /**
     * Delete inner html of overlay (regardless of whether it is shown or hidden)
     */
  }, {
    key: "clear",
    value: function clear() {
      try {
        var qs = "#saito-overlay".concat(this.ordinal);
        var overlay_el = document.querySelector(qs);
        if (overlay_el) {
          if (this.closebox) {
            overlay_el.innerHTML = "<div id=\"saito-overlay-closebox".concat(this.ordinal, "\" class=\"saito-overlay-closebox\"><i class=\"fas fa-times-circle saito-overlay-closebox-btn\"></i></div>");
          } else {
            overlay_el.innerHTML = '';
          }
        }
      } catch (err) {
        console.error(err);
      }
    }

    /**
     * TODO -- improve this module
     *
     * A specific function for Twilight that allows for more advanced display formatting through parameters
     * options. Also Imperium:
     *
     *      columns
     *      backgroundImage
     *      title
     *      subtitle
     *      padding
     *      textAlign
     *
     *      cardListWidth
     *      cardListHeight
     *      unselectableCards
     *      onContinue
     *      onClose
     *
     *    -- DEPRECATED -- rowGap, columnGap
     */
  }, {
    key: "showCardSelectionOverlay",
    value: function showCardSelectionOverlay(app, game_mod, cards) {
      var _this4 = this;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      //Get Styling Options
      var wrapper_style = options.padding ? "padding:".concat(options.padding, ";") : '';
      wrapper_style += options.backgroundImage ? "background-image: url(".concat(options.backgroundImage, "); background-size: cover;") : 'background-color: #111D;';
      wrapper_style += options.textAlign ? "text-align:".concat(options.textAlign, ";") : '';

      //Start building HTML
      var html = "<div style=\"".concat(wrapper_style, "\">");
      if (options.title) {
        html += "<div class=\"game-overlay-cardlist-title\">".concat(options.title, "</div>");
      }
      if (options.subtitle) {
        html += "<div class=\"game-overlay-cardlist-subtitle\">".concat(options.subtitle, "</div>");
      }
      var unselectable_cards = options.unselectableCards ? options.unselectableCards : [];
      html += '<div class="hide-scrollbar game-overlay-cardlist-container">';
      for (var i in cards) {
        var thishtml = '<div class="game-overlay-cardlist-card">';
        if (cards[i] != undefined) {
          var x = 0;
          if (_typeof(cards[i]) === 'object' && !Array.isArray(cards[i]) && cards[i] != null) {
            if (cards[i].returnCardImage != 'undefined' && cards[i].returnCardImage != null) {
              thishtml += cards[i].returnCardImage();
              x = 1;
            }
          }
          if (x == 0) {
            if (Array.isArray(cards)) {
              thishtml += game_mod.returnCardImage(cards[i]);
            } else {
              thishtml += game_mod.returnCardImage(i);
            }
          }
        } else {
          thishtml += game_mod.returnCardImage(i);
        }
        thishtml += '</div>';

        //
        // is this unselectable?
        //
        for (var p = 0; p < unselectable_cards.length; p++) {
          if (JSON.stringify(unselectable_cards[p]) === JSON.stringify(cards[i])) {
            thishtml = thishtml.replace(/game-overlay-cardlist-card/g, 'game-overlay-cardlist-card game-overlay-cardlist-unselectable');
          }
        }
        html += thishtml;
      }
      html += '</div>'; //close .game-overlay-cardlist-container

      //Check options for buttons
      var has_continue_button = 1;
      var has_close_button = 1;
      if (!options.onClose) {
        options.onClose = function () {};
        has_close_button = 0;
      }
      if (!options.onContinue) {
        options.onContinue = function () {};
        has_continue_button = 0;
      }
      if (has_continue_button || has_close_button) {
        html += '<div class="game-overlay-button-container">';
        if (has_continue_button) {
          html += "<div class=\"game-overlay-button-continue button game-overlay-cardlist-button\">continue</div>";
        }
        if (has_close_button) {
          html += "<div class=\"game-overlay-button-close button super game-overlay-cardlist-button\">close</div>";
        }
        html += '</div>';
      }
      html += '</div>'; //close wrapper div

      //Show Overlay
      this.show(html, options.onClose);

      // set min height of cardlist card elements
      //
      document.querySelectorAll('.game-overlay-cardlist-card').forEach(function (el) {
        if (el.children) {
          el.style.height = _this4.calculateElementHeight(el.children[0]);
        }
      });

      //
      // set width/height
      //
      var cardlist_container_height = options.cardlistHeight || '80vh';
      var cardlist_container_width = options.cardlistWidth || '80vw';
      document.querySelector('.game-overlay-cardlist-container').style.width = cardlist_container_width;
      document.querySelector('.game-overlay-cardlist-container').style.height = 'auto';
      document.querySelector('.game-overlay-cardlist-container').style.maxWidth = cardlist_container_width;
      document.querySelector('.game-overlay-cardlist-container').style.maxHeight = cardlist_container_height;

      //
      // right-align left card if only 2
      //
      if (cards.length == 2) {
        var el = document.querySelector('.game-overlay-cardlist-container');
        if (el) {
          el.style.justifyItems = 'unset';
          var el2 = el.children[0];
          if (el2) {
            var el3 = el2.children[0];
            if (el3) {
              el3.style["float"] = 'right';
            }
          }
        }
      } else {
        var _el = document.querySelector('.game-overlay-cardlist-container');
        if (_el) {
          _el.style.justifyItems = 'center';
        }
      }

      //
      // center single card
      //
      if (cards.length == 1) {
        var _el2 = document.querySelector('.game-overlay-cardlist-card');
        _el2.style.marginRight = 'auto';
        _el2.style.marginLeft = 'auto';
      }

      // Apply Functionality to the buttons
      //
      if (has_continue_button) {
        document.querySelector('.game-overlay-button-continue').onclick = function (e) {
          options.onContinue();
        };
      }
      if (has_close_button) {
        document.querySelector('.game-overlay-button-close').onclick = function (e) {
          options.onClose();
        };
      }

      //
      // if cards are selectable
      //
      if (options.onCardSelect) {
        document.querySelectorAll('.game-overlay-cardlist-card').forEach(function (el) {
          el.onclick = function (e) {
            var cardname = el.getAttribute('id');
            if (cardname == null) {
              if (el.children) {
                cardname = el.children[0].getAttribute('id');
              }
            }
            options.onCardSelect(cardname);
          };
        });
        document.querySelectorAll('.game-overlay-cardlist-unselectable').forEach(function (el) {
          el.onclick = function (e) {};
        });
      }

      // update number shown
      if (options.columns > 0) {
        var _x = '1fr ';
        for (var y = 1; y < options.columns; y++) {
          _x += '1fr ';
        }
        document.querySelector('.game-overlay-cardlist-container').style.gridTemplateColumns = _x;
      } else {
        document.querySelector('.game-overlay-cardlist-container').style.gridTemplateColumns = '1fr 1fr 1fr 1fr';
      }
    }

    /**
     * copy of gamehud function needed for showCardSelectionOverlay
     *
     */
  }, {
    key: "calculateElementHeight",
    value: function calculateElementHeight(elm) {
      if (document.all) {
        // IE
        elmHeight = elm.currentStyle.height;
        elmMargin = parseInt(elm.currentStyle.marginTop, 10) + parseInt(elm.currentStyle.marginBottom, 10);
      } else {
        // Mozilla
        elmHeight = document.defaultView.getComputedStyle(elm, '').getPropertyValue('height');
        elmMargin = parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-top')) + parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-bottom'));
      }
      return parseInt(elmHeight) + parseInt(elmMargin) + 'px';
    }
  }, {
    key: "setBackground",
    value: function setBackground() {
      var img_path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var dark = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var qs = "#saito-overlay-backdrop".concat(this.ordinal);
      var overlay_backdrop_el = document.querySelector(qs);
      if (overlay_backdrop_el) {
        if (dark == true) {
          overlay_backdrop_el.style.background = 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), url("' + img_path + '")';
          overlay_backdrop_el.style.backgroundSize = 'cover';
          overlay_backdrop_el.style.opacity = 1;
        } else {
          overlay_backdrop_el.style.backgroundImage = 'url("' + img_path + '")';
          overlay_backdrop_el.style.backgroundSize = 'cover';
          overlay_backdrop_el.style.opacity = 1;
        }
      }
    }
  }, {
    key: "setBackgroundColor",
    value: function setBackgroundColor() {
      var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#000';
      var qs = "#saito-overlay-backdrop".concat(this.ordinal);
      var overlay_backdrop_el = document.querySelector(qs);
      if (overlay_backdrop_el) {
        overlay_backdrop_el.style.backgroundColor = color;
        if (color.length < 4) {
          overlay_backdrop_el.style.opacity = 1;
        }
      }
    }
  }]);
}();
module.exports = SaitoOverlay;